export default {
    SET_AUTH_USER(state, value) {
        state.authUser = value;
    },
};